import React from "react";

import { IntlShape } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./getSuccessNotificationNode.module.scss";

const getSuccessNotificationNode = (
  intl: IntlShape | undefined,
  message: string,
  onViewClick?: () => void
) => (
  <div className={styles.container}>
    <span>{message}</span>
    {onViewClick && (
      <Button onClick={onViewClick}>
        {intl?.formatMessage({
          id: "createEntity.notification.success.link",
          defaultMessage: "View",
          description: "Link for any creating entity modal to view result",
        }) ?? "View"}
      </Button>
    )}
  </div>
);

export default getSuccessNotificationNode;
